import { Component, Input, NgZone, OnInit, OnChanges, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { CSEService } from '../../services/cse.service';
import { UtilService } from '../../services/util.service';
import { SearchCarrierContract } from '../../models/models';

@Component({
    selector: 'carrier-contract-grid',
    templateUrl: './carrier-contract-grid.component.html',
    standalone: false
})
export class CarrierContractGrid implements OnInit, OnChanges {
    @Input() isNonExpired: boolean = false;
    @ViewChild(GridComponent, { static: false }) public carrierContractGrid!: GridComponent;

    public contractListOrig: SearchCarrierContract[] = [];
    public contractList: SearchCarrierContract[] = [];
    public carrierContractID: number = -1;
    public masterQuoteOrderLineID: number = 0;
    public quoteOrderLineID: number = 0;
    public utcNow: Date = new Date();

    public gridState: State = { skip: 0, take: 10 };
    public gridData: GridDataResult = { data: [], total: 0 };

    constructor(private cseService: CSEService, private utilService: UtilService, private ngZone: NgZone) {
    }

    ngOnInit() {
        this.utcNow = this.utilService.getDateAsUTC(new Date());
        this.getContracts();
    }

    ngOnChanges() {
        this.filterContracts();
    }

    private getContracts() {
        this.carrierContractID = -1;
        this.utilService.isLoading = true;
        this.cseService.getSearchCarrierContractLatest().subscribe(result => {
            this.utilService.isLoading = false;
            this.contractListOrig = result.resultCollection;
            this.filterContracts();
            //this.setGrid();
            //console.log("getContracts", this.contractList);
        });
    }

    private filterContracts() {
        if (this.isNonExpired != true) {
            this.contractList = this.contractListOrig.filter(t => t.isExpired == true || t.isIncomplete == true);
        }
        else {
            this.contractList = this.contractListOrig;
        }
        this.setGrid();
        //console.log("filterContracts", this.isNonExpired, this.contractList);
    }

    public refreshContracts() {
        this.contractList.length = 0;
        this.getContracts();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.carrierContractGrid == null) return;
            this.carrierContractGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        this.gridState = state;
        this.setGrid();
    }

    public setGrid() {
        this.gridData = process(this.contractList, this.gridState);
        this.fitColumns();
    }

    public edit(carrierContract: SearchCarrierContract) {
        this.carrierContractID = (carrierContract.carrierContractID == null ? 0 : carrierContract.carrierContractID);
        this.masterQuoteOrderLineID = carrierContract.parentQuoteOrderLineID;
        this.quoteOrderLineID = carrierContract.quoteOrderLineID;
        //console.log("edit:carrierContractID", this.carrierContractID, carrierContract);
    }
}
